import { ProductContext } from '@root/modules/Sellers/provider/ProductProvider';
import AttachDown from '@root/modules/Warehouse/Inquiry/components/attachment/AttachDown';
import Comment from '@root/modules/Warehouse/Inquiry/components/comment';
import inquiryService from '@root/modules/Warehouse/Inquiry/service/inquiry';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IComment } from '../../interface';
import CmtCreate from './comment/CmtCreate';
import CmtEdit from './comment/CmtEdit';
import CmtToDown from './comment/CmtToDown';

interface Prop {
  setLoadingCmt?: boolean;
  statusWarehouse?: string;
}
const WAREHOUSE = 'Warehouse';

const CommentWarehouse = ({ setLoadingCmt, statusWarehouse }: Prop) => {
  const { id }: any = useParams();
  const [listCmt, setListCmt] = useState<IComment[]>([]);
  const [myLastComment, setLMyLastComment] = useState<IComment>();

  const [listImgCreate] = useContext<any>(ProductContext);

  /*------------------- get comment list ----------*/
  const _getData = useCallback(async () => {
    if (id) {
      const responseData = await inquiryService.getListComment(id);
      const commentList = responseData.data;
      setListCmt(commentList);
      const lastComment: IComment = commentList.at(-1);

      if (lastComment?.owner === 'Warehouse') {
        setLMyLastComment(lastComment);
      }
    }
  }, [id]);

  useEffect(() => {
    _getData();
  }, [_getData]);
  /*----------------update quotation---------*/

  const [openEdit, setOpenEdit] = useState(false);
  const [close, setClose] = useState(false);
  const [openDownImg, setOpenDownImg] = useState(false);
  const [openAddCmt, setOpenAddCmt] = useState(false);

  const handleOpenEdit = () => {
    setOpenDownImg(true);
    setClose(true);
  };
  /*---------get name img----*/

  return (
    <div style={{ marginTop: '15px', gap: '10px' }}>
      <div style={{ marginTop: '15px', gap: '10px' }}>
        {listCmt.map((item, index) => (
          <div key={index}>
            {item.owner === 'Warehouse' ? (
              <>
                {myLastComment ? (
                  <>
                    {index === listCmt.length - 1 ? (
                      <>
                        {!openEdit && (
                          <CmtToDown
                            openDownImg={openDownImg}
                            setOpenEdit={setOpenEdit}
                            setOpenDownImg={setOpenDownImg}
                            listClone={myLastComment}
                            statusWarehouse={statusWarehouse}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <AttachDown
                            label={item.owner}
                            documents={item.documents}
                          />
                          <Comment
                            title={item.owner}
                            date={item.created_at}
                            content={item.comment}
                            btnText=""
                          />
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <AttachDown
                        label={item.owner}
                        documents={item.documents}
                      />
                      <Comment
                        title={item.owner}
                        date={item.created_at}
                        content={item.comment}
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <div key={index} style={{ display: 'flex', gap: '10px' }}>
                <AttachDown label={item.owner} documents={item.documents} />
                <Comment
                  title={item.owner}
                  date={item.created_at}
                  content={item.comment}
                />
              </div>
            )}
          </div>
        ))}

        {openDownImg && (
          <CmtToDown
            openDownImg={openDownImg}
            setOpenEdit={setOpenEdit}
            setOpenDownImg={setOpenDownImg}
            listClone={myLastComment}
          />
        )}
        {listCmt.length === 0 ? null : (
          <>
            {!myLastComment?.documents && (
              <CmtCreate
                statusWarehouse={statusWarehouse}
                _getData={_getData}
              />
            )}
          </>
        )}
        {openEdit && (
          <CmtEdit
            inquiryId={id}
            onSubmitted={() => {
              setOpenEdit(false);
              setOpenDownImg(false);
              setClose(false);
              _getData();
            }}
            comment={myLastComment}
            setLoadingCmt={setLoadingCmt}
          />
        )}
      </div>
    </div>
  );
};

export default CommentWarehouse;
